import './InfoSection.css';
import pikeauv from '../assets/pike_auv.png';

const InfoSection = () => {
  const features = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      ),
      title: "Dual-Use Systems",
      description: "Platforms designed for both defence operations and civilian applications—from mine countermeasures to infrastructure inspection."
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      ),
      title: "Operational Efficiency",
      description: "Reduced costs and downtime compared to traditional manned operations. Small footprint, high impact."
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
          <path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/>
        </svg>
      ),
      title: "Modular Architecture",
      description: "Mission-ready systems with flexible sensor integration and payload options for rapid adaptation to different operational needs."
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      ),
      title: "Situational Awareness",
      description: "From autonomous surveys to passive monitoring—turning underwater blind spots into controlled, observable domains."
    }
  ];

  return (
    <section className="about" id="about">
      <div className="container">
        {/* Section Header */}
        <div className="about-header">
          <span className="section-label">About Us</span>
          <h2 className="section-title">
            What We
            <span className="gradient-text"> Do</span>
          </h2>
          <p className="section-subtitle">
            SUBmerge Baltic develops unmanned underwater vehicles and maritime monitoring systems
            for defence, security, and critical infrastructure protection.
          </p>
        </div>

        {/* Mission Statement */}
        <div className="about-mission">
          <div className="mission-content">
            <h3>Our Mission</h3>
            <p>
              We provide operators with underwater situational awareness and intervention capability—without
              the cost, complexity, or risk of traditional manned operations. Our systems enable defence forces,
              port authorities, and infrastructure operators to detect threats, inspect assets, and respond to
              incidents with precision and confidence.
            </p>
            <div className="mission-stats">
              <div className="mission-stat">
                <span className="mission-stat-value">ROV</span>
                <span className="mission-stat-label">Real-time Control</span>
              </div>
              <div className="mission-stat">
                <span className="mission-stat-value">AUV</span>
                <span className="mission-stat-label">Autonomous Ops</span>
              </div>
              <div className="mission-stat">
                <span className="mission-stat-value">24/7</span>
                <span className="mission-stat-label">Monitoring</span>
              </div>
            </div>
          </div>
          <div className="mission-visual">
            <img src={pikeauv} alt="PIKE AUV Underwater Drone" className="mission-image" />
          </div>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
